<template>
  <div>
    <div onContextMenu="return(false)" id="urlc__bu__tabulator-attributes" ref="table"></div>
    <button
      type="button"
      class="controls__button controls__button_add_row"
      @click="addRow"
    >
      <base-material-design-icon icon="plus" class="controls__icon" />
      <span>Add Row</span>
    </button>
    <base-material-design-icon style="font-size:14px;" ref="icon" icon="closeCircle" />
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Tabulator from 'tabulator-tables'
import BaseModalMixins from '@/common/BaseModalMixins'

const actionPlaceholder = 'add'
const attributePlaceholder = '- attribute -'

export default {
  name: 'BulkUpdateAttributes',
  mixins: [BaseModalMixins],
  data () {
    return {
      table: null,
      rowId: 0,
      tableData: [{ action: actionPlaceholder, url_attribute: attributePlaceholder }],
      rawIconHtmlString: ''
    }
  },
  computed: {
    ...mapState('urlCensus', ['attributes'])
  },
  watch: {
    attributes: {
      handler () {
        this.table.getColumn('url_attribute').getDefinition().editorParams.values = this.attributes
        this.table.redraw()
      },
      deep: true
    }
  },
  methods: {
    addRow () {
      this.rowId += 1
      this.table.addRow({ id: this.rowId, close_button: 1, action: actionPlaceholder, url_attribute: attributePlaceholder })
      this.table.scrollToRow(this.rowId)
    }
  },
  mounted () {
    this.rawIconHtmlString = this.$refs.icon.$el.outerHTML.toString()
    this.$refs.icon.$el.parentNode.removeChild(this.$refs.icon.$el)

    const vueComponent = this
    this.table = new Tabulator(this.$refs.table, {
      data: vueComponent.tableData,
      layout: 'fitColumns',
      movableColumns: false,
      headerVisible: false,
      cellVertAlign: 'middle',
      maxHeight: 170,
      dataChanged (data) {
        data = data.filter(row => row.action && row.url_attribute && row.url_attribute !== attributePlaceholder)
        data = data.map(row => ({ action: row.action, attribute: row.url_attribute }))
        if (data && data.length) {
          vueComponent.$emit('attributeData', data)
        }
      },
      columns: [
        {
          title: '',
          field: 'close_button',
          hozAlign: 'center',
          resizable: false,
          headerSort: false,
          minWidth: 50,
          width: 50,
          formatter: function (cell, formatterParams, onRendered) { // plain text value
            return vueComponent.rawIconHtmlString // this provides material-design-icon as raw html
          },
          cellClick: function (e, cell) {
            const rowCount = cell.getTable().getDataCount()
            const row = cell.getRow()
            if (rowCount === 1) {
              row.getCell('action').setValue(actionPlaceholder)
              row.getCell('url_attribute').setValue(attributePlaceholder)
            } else {
              row.delete()
            }
          }
        },
        {
          title: 'Add/Remove',
          field: 'action',
          editor: 'select',
          resizable: false,
          width: 150,
          editorParams: {
            values: ['add', 'remove']
          }
        },
        {
          title: 'Attribute',
          field: 'url_attribute',
          resizable: false,
          headerSort: false,
          minWidth: 100,
          cellEditing (cell) {
            if (cell.getValue() === attributePlaceholder) {
              cell.setValue('')
            }
          },
          editor: 'autocomplete',
          editorParams: {
            showListOnEmpty: true,
            values: vueComponent.attributes
          },
          //   mutator (value, data, type, params, component) {
          //     return vueComponent.attributes[value] === undefined ? value : vueComponent.attributes[value]
          //   }
          formatter (cell) {
            let value = cell.getValue()
            return vueComponent.attributes[value] || attributePlaceholder
          }
        }
      ]

    })
  }
}

</script>

<style>
#urlc__bu__tabulator-attributes .tabulator-cell {
  height: 40px;
}
</style>

<style scoped lang="scss">

  .controls {
    display: flex;
    margin-top: 30px;

    &__icon {
      margin-right: 2px;
      font-size: 15px;
    }

    &__button {
      height: 40px;
      width: 15%;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      border: none;
      outline: none;
      cursor: pointer;

      color: $rfx-dark-march;
      background-color: #fff;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }

      &_add_row {
        width: 100%;
      }

      &_cancel {
        margin-left: auto;
        margin-right: 10px;
      }
    }
  }

</style>
